import React from "react";

export function Action({ action }) {
  if (action.when === false) {
    return null;
  }

  // if (action.component) {
  //   return action.component();
  // }

  // if (action.type === "link") {
  //   return (
  //     <Link
  //       to={action.href}
  //       state={action.state ?? {}}
  //       className={action.className ?? "btn btn--icon"}
  //       aria-label={action.balloonLabel}
  //       data-balloon-pos={action.balloonLabelPosition ?? "left"}
  //     >
  //       <action.icon />
  //     </Link>
  //   );
  // }

  // if (action.type === "anchor") {
  //   return (
  //     <a
  //       className={action.className ?? "btn btn--icon"}
  //       href={action.href}
  //       aria-label={action.balloonLabel}
  //       data-balloon-pos={action.balloonLabelPosition ?? "left"}
  //     >
  //       <action.icon />
  //     </a>
  //   );
  // }

  return (
    <button
      className={action.className ?? "btn btn--icon"}
      onClick={action.onClick}
      aria-label={action.balloonLabel}
      data-balloon-pos={action.balloonLabelPosition ?? "left"}
      disabled={action.disabled ?? false}
    >
      <action.icon />
    </button>
  );
}

export default function AppHeading({ title, subtitle, rightActions = [] }) {
  const DEFAULT_TITLE = `Go See TV Insights Portal`;
  const DEFAULT_SUBTITLE = `Welcome back, let's see how your channels are doing.`;

  return (
    <div className="app-heading">
      <div className="app-heading__title">{title || DEFAULT_TITLE}</div>
      <div className="app-heading__subtitle">
        {subtitle || DEFAULT_SUBTITLE}
        {rightActions.length ? (
          <div className="app-heading__action-list">
            {rightActions.map((action, index) => (
              <Action action={action} key={index} />
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}
